import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustrySample } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippSamplesReportedSlice = new RestSlice<IppIndustrySample>(
	localizationService.getLocalizedString('ipp.samples.samplesReported'),
	Resource.IppIndustrySamples
);
export default ippSamplesReportedSlice.rests.reducer;
